import {IFormaPagamento} from "@models/formaPagamento/IFormaPagamento.ts";
import {useFormaPagamento} from "@components/formaPagamento/hooks/useFormaPagamento.ts";
import {TableCell, TableRow} from "@mui/material";
import {DefaultInfoProps} from "@models/DefaultProps.ts";
import {FormaPagtoInfoNav} from "@components/formaPagamento/info/FormaPagtoInfoNav.tsx";
import {CheckOutlined, ClearOutlined} from "@mui/icons-material";

interface FormaPagtoInfoRowProps extends DefaultInfoProps<IFormaPagamento | number> {
}

export function FormaPagtoInfoRow(props: FormaPagtoInfoRowProps) {
    const {useFormaPagamentoValue} = useFormaPagamento()

    const [value] = useFormaPagamentoValue(props.value)

    return (value != null &&
        <TableRow>
            <TableCell>{value.id}</TableCell>
            <TableCell><FormaPagtoInfoNav {...props} tableMode={true} value={value}/></TableCell>
            <TableCell>{value.isAtivo ? <CheckOutlined/> : <ClearOutlined/>}</TableCell>
            <TableCell>{value.isAntecipacao ? <CheckOutlined/> : <ClearOutlined/>}</TableCell>
        </TableRow>

    )
}

